import './index.scss';
import React, { useEffect, useState } from 'react';
import { lang } from '@umu/ukit-lang';
import { DepartmentSelectDialog } from 'businessCommon/src/components';
import { If } from 'common/src/components';
import { MemberSearchInput, Account, SELECTED_CARD, IDepartment } from './components/memberSearchInput';
import { EPlatformTravelType } from '@umu/umu-types';
import ImageMoreArrow from './images/icon-more-arrow.png';
import ImageDepartment from './images/icon-architecture.png';
import { isSame, getUniqueList } from '@umu/umu-util';
import { usePrev } from '@umu/umu-react-hooks';
import { Modal } from '@umu/umu-design';
export type { Account, SELECTED_CARD, IDepartment } from './components/memberSearchInput';

interface IProps {
    placeholder: string;
    searchSource: string;

    autoFocus?: boolean;
    /**
     * 账号搜索的额外参数？
     */
    paramExtend?: { [key: string]: any };
    /**
     * 是否隐藏输入框内的搜索图标
     */
    hasCleanBtn?: boolean;
    defaultValue?: SELECTED_CARD[];
    showDepartmentSelector?: boolean;
    onChange(data: SELECTED_CARD[]): void;
    filter?(account: Account): boolean;
    onFocus?: VoidFunction;
    onBlur?: VoidFunction;
    onDelete?(data: SELECTED_CARD[]): void;
    onResultChange?(results: Account[]): void;
}
const { confirm } = Modal;
export const MemberSelector = (props: IProps) => {
    const { defaultValue = [], showDepartmentSelector = false } = props;
    const [list, setList] = useState(defaultValue);
    const prevList = usePrev(list);

    const unique = (arr: SELECTED_CARD[]) => {
        return getUniqueList(arr, (a, b) => a.account_type === b.account_type && a.account === b.account);
    };

    useEffect(() => {
        if (Array.isArray(prevList) && !isSame(prevList, list)) {
            props.onChange(list);
        }
    }, [list]);

    useEffect(() => {
        setList(defaultValue);
    }, [JSON.stringify(defaultValue)]);

    const cbDo = (data: any[]) => {
        const departments = data.map((item) => {
            return {
                account_type: 'department',
                id: item.department_id,
                department_id: item.department_id,
                account: item.department_name,
                department_name: item.department_name,
            } as IDepartment;
        });
        const delExcessList = list.filter((item) => {
            return item.account_type !== 'department' || !!departments.some((v) => v.id === item.id);
        }, []);
        setList(unique([...delExcessList, ...departments]));
    };

    const onInputChange = (data: SELECTED_CARD[]) => {
        setList(data);
    };

    const onAddDepartment = () => {
        const defaultSelectedList = list
            .filter((item) => {
                return item.account_type === 'department';
            })
            .map((_) => (_ as IDepartment).id)
            .toString();
        const dialog = confirm({
            title: '',
            centered: true,
            footer: null,
            closable: false,
            width: 'auto',
            zIndex: 10000,
            className: 'member-department-selector',
            content: (
                <DepartmentSelectDialog
                    isRadio={false}
                    title={lang('选择部门')}
                    departmentId={''}
                    btnConfirmType="primary-blue"
                    travelType={EPlatformTravelType.department}
                    defaultSelectedList={defaultSelectedList}
                    cbClose={() => dialog.destroy()}
                    excludeDepartmentIds={'0'}
                    cbDo={(data) => {
                        cbDo(data);
                        dialog.destroy();
                    }}
                />
            ),
        } as any);
    };

    return (
        <div className={`member-selector flex--start ${showDepartmentSelector ? 'with-department' : ''}`}>
            <div className="flex--1">
                <MemberSearchInput {...props} defaultValue={list} onChange={onInputChange} />
            </div>
            <If condition={showDepartmentSelector}>
                <button className="department-btn flex--center" onClick={onAddDepartment}>
                    <img src={ImageDepartment} className="icon-department" />
                    <span>{lang('选择部门')}</span>
                    <img src={ImageMoreArrow} className="icon-more-arrow" />
                </button>
            </If>
        </div>
    );
};
